import { render } from "./RomanDetail.vue?vue&type=template&id=210ecbe6&scoped=true"
import script from "./RomanDetail.vue?vue&type=script&lang=js"
export * from "./RomanDetail.vue?vue&type=script&lang=js"

import "./RomanDetail.vue?vue&type=style&index=0&id=210ecbe6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210ecbe6"]])

export default __exports__